import { CartAddEvent } from '@theme/events';

/*
 * Shared Add to Cart + View Cart behaviour for the ABCmouse x ClassWallet homepage cards.
 * - [data-add-to-cart][data-variant] : adds the variant, updates the drawer/bubble via the
 *   theme CartAddEvent, opens the cart drawer, then auto-closes it after AUTO_CLOSE_MS.
 * - [data-open-cart] : opens the cart drawer (stays open; used by "View Cart").
 * - Keeps the header "View Cart" count badge (.aofl-cart-count) in sync with the cart.
 */
(() => {
  if (window.__aoflCartInit) return;
  window.__aoflCartInit = true;

  const AUTO_CLOSE_MS = 4000;

  const getDrawer = () => document.querySelector('cart-drawer-component');

  const openDrawer = () => {
    const d = getDrawer();
    if (d && typeof d.open === 'function') d.open();
  };

  const closeSoon = () => {
    const d = getDrawer();
    if (!d) return;
    clearTimeout(d.__aoflTimer);
    d.__aoflTimer = setTimeout(() => {
      if (typeof d.close === 'function') d.close();
    }, AUTO_CLOSE_MS);
  };

  // Keep the header View Cart badge in sync with the actual cart.
  const refreshBadge = () => {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        document.querySelectorAll('.aofl-cart-count').forEach((el) => {
          if (c.item_count > 0) {
            el.textContent = c.item_count;
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
      })
      .catch(() => {});
  };

  const sectionIds = () => {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids.join(',');
  };

  const addToCart = (variantId, sourceEl) => {
    if (!variantId) return;
    const fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    const ids = sectionIds();
    if (ids) fd.append('sections', ids);

    const url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data && data.status) {
          console.error('[aofl-cart]', data.description || data.message);
          return;
        }
        (sourceEl || document.body).dispatchEvent(
          new CartAddEvent({}, String(variantId), {
            source: 'aofl-cards',
            itemCount: 1,
            variantId: String(variantId),
            sections: data && data.sections,
          })
        );
        openDrawer();
        closeSoon();
        refreshBadge();
      })
      .catch((err) => console.error('[aofl-cart] add failed', err));
  };

  document.addEventListener('click', (e) => {
    const atc = e.target.closest('[data-add-to-cart]');
    if (atc) {
      e.preventDefault();
      if (atc.getAttribute('aria-disabled') === 'true') return;
      addToCart(atc.getAttribute('data-variant'), atc);
      return;
    }
    const open = e.target.closest('[data-open-cart]');
    if (open) {
      e.preventDefault();
      openDrawer();
    }
  });

  // Any cart update (from our cards or the drawer) refreshes the badge.
  document.addEventListener(CartAddEvent.eventName, refreshBadge);
  // This module is deferred, so the DOM is already parsed: refresh now (and once more
  // shortly after, in case the header section renders late / was cached with a stale count).
  refreshBadge();
  setTimeout(refreshBadge, 600);
})();